import {IntermediatePart} from "../../intermediatePart";

export default class PonyWallGlass extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'pony_wall_glass';
    this.isPonyWallPart = true;
    this.visible = true;
    this.partName = 'Pony Wall Glass';
    this.translateId = "visualizer.bathroom.shower.pony_wall_glass";
    this.isStoneFeature = false;
    this.disableOnHomeSections = true;
    this.layerPriority = 10;
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    const showerParent = this.getParent();
    if (showerParent && showerParent.showerDoor && showerParent.showerDoor.activeFeature) {
      if (showerParent.showerDoor.activeFeature.metaData["ShowerPanHeight"]) {
        conditions.push({
          propName: "ShowerPanHeight",
          propValue: showerParent.showerDoor.activeFeature.metaData["ShowerPanHeight"]
        })
      }
      if (showerParent.showerDoor.activeFeature.metaData["DoorHeight"]) {
        conditions.push({
          propName: "DoorHeight",
          propValue: showerParent.showerDoor.activeFeature.metaData["DoorHeight"]
        })
      }
      if (showerParent.showerDoor.activeFeature.metaData["PonyWallGlass"]) {
        conditions.push({
          propName: "DoorHeight",
          propValue: showerParent.showerDoor.activeFeature.metaData["PonyWallGlass"] // "off"
        })
      }
    }
    return conditions
  }

}
